import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IdNomModel } from '../../models/IdNomModel';
import { CacheService } from '../../services/cache-service';
import { ConfigurationService } from '../../services/configuration.service';
import { GuidService } from '../../services/guid.service';

@Component({
  selector: 'app-type-action-dropdown',
  templateUrl: './type-action-dropdown.component.html',
  styleUrls: ['./type-action-dropdown.component.css']
})
export class TypeActionDropdownComponent implements OnInit {
  @Input() editMode: boolean = true;
  @Input() showClear: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() placeholder: string = ''; // Sélectionner un taux de TVA
  pDropdownStyle: any = {};
  minWidth: string = '84px';

  private _typeId: number;
  @Input()
  set typeId(value: number) {
    this._typeId = value;
    this.selectType();
  }
  get typeId(): number {
    return this._typeId;
  }

  _type: IdNomModel = null;
  @Input()
  set type(value: IdNomModel) {
    this._type = value;
  }
  get type(): IdNomModel {
    return this._type ? this._type : null;
  }

  @Input() inputFocus: string;
  @Input() inputFocusValue: string;

  @Output() typeIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() typeChange: EventEmitter<IdNomModel> = new EventEmitter<IdNomModel>();
  @Output() inputFocusChange: EventEmitter<string> = new EventEmitter<string>();

  public types: IdNomModel[] = [];
  public guid: string;
  public typesLoaded: boolean = false;

  constructor(
    configurationService: ConfigurationService,
    private guidService: GuidService,
    private cacheService: CacheService
  ) {
    this.pDropdownStyle = { ...configurationService.pDropdownStyle, 'min-width': this.minWidth };
  }

  ngOnInit() {
    this.guid = this.guidService.newGuid();
    if (!this.typesLoaded) {
      this.loadTypes();
    } else {
      this.selectType();
    }
  }

  selectType() {
    if (this.typesLoaded) {
      setTimeout(() => {
        this.type = this.types.find((t) => this._typeId != null && this._typeId != undefined && t.Id == this._typeId);
      });
    }
  }

  loadTypes() {
    this.cacheService.getTypeActions().subscribe((types) => {
      this.types = types;
      this.typesLoaded = true;
      this.selectType();
    });
  }

  inputFocusChanged(value) {
    this.inputFocus = value;
    this.inputFocusChange.emit(this.inputFocus);
  }

  typeChanged() {
    if (this.typesLoaded) {
      if (this._typeId != this._type?.Id) {
        this._typeId = this._type?.Id;
        this.typeIdChange.emit(this._typeId);
        this.typeChange.emit(this._type);
      }
    }
  }
}
